import React from 'react';
import { number, string } from 'prop-types';
import { LinearProgress, Flex } from '../../atoms';
import { StarIcon, Line, Score, Count } from './rating-line.styles';

function RatingLine({
  id,
  score,
  count,
  max,
  starColor,
  lineColor,
  fontweightScore,
  countColor,
  widthProgress,
  heightProgress,
  starSize,
  scoreFontSize,
  columnGap,
  as
}) {
  return /*#__PURE__*/React.createElement(Line, {
    columnGap: columnGap,
    as: as
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Score, {
    fontSize: scoreFontSize,
    fontWeight: fontweightScore
  }, id), /*#__PURE__*/React.createElement(StarIcon, {
    width: starSize,
    height: starSize,
    color: starColor
  })), /*#__PURE__*/React.createElement(LinearProgress, {
    height: heightProgress,
    width: widthProgress,
    value: score,
    max: max,
    color: lineColor
  }), /*#__PURE__*/React.createElement(Count, {
    "data-testid": "rating-value",
    fontSize: scoreFontSize,
    color: countColor
  }, count));
}

RatingLine.defaultProps = {
  id: 0,
  score: 0,
  count: '0',
  widthProgress: '90px',
  heightProgress: '6px',
  as: 'li',
  starSize: 15,
  scoreFontSize: 0,
  columnGap: 8
};
process.env.NODE_ENV !== "production" ? RatingLine.propTypes = {
  as: string,
  id: number,
  score: number,
  count: string,
  max: number,
  lineColor: string,
  starColor: string,
  fontweightScore: string,
  countColor: string,
  widthProgress: string,
  heightProgress: string,
  starSize: number,
  scoreFontSize: number,
  columnGap: number
} : void 0;
export default RatingLine;